import { pageConstant } from "../_constants/pageConstant";
import { pageService } from "../_services/pageService";
import { alert } from "../_utilities/alert";

export const pageAction = {
  getPages,
};

function getPages() {
  return (dispatch) => {
    dispatch(
      dispatchFunction({
        type: pageConstant.PAGE_REQUEST,
        data: null,
      })
    );
    pageService
      .getPages()
      .then(
        (response) => {
          if (response.Status === 200) {
            dispatch(
              dispatchFunction({
                type: pageConstant.PAGE_SUCCESS,
                data: response.Result.page,
              })
            );
          } else {
            dispatch(
              dispatchFunction({
                type: pageConstant.PAGE_FAILURE,
                data: null,
              })
            );
          }
        },
        (error) => {
          dispatch(
            dispatchFunction({
              type: pageConstant.PAGE_FAILURE,
              data: error,
            })
          );
        }
      )
      .catch(() => {
        alert.error("Oops! Something went wrong!!");
      });
  };
}



function dispatchFunction(data) {
  console.log(149, data);
  return {
    type: data.type,
    data: data.data,
  };
}
